import dotProp from 'dot-prop-immutable'
import perMeterCalc from '../../utils/perMeterCalc'

const getProp = (key, { prefix = '', suffix = '' }, defaultValue = '') => props =>
  key in props && props[key] !== null && props[key] !== undefined ? `${prefix}${props[key]}${suffix}` : defaultValue

const getPropOrTheme = (key, { prefix = '', suffix = '' }, path = '') => props =>
  getProp(key, { prefix, suffix }, path)(props) !== path
    ? getProp(key, { prefix, suffix }, path)(props)
    : dotProp.get(props, path)

const scaleXtoY = (x, y) => (x * 100) / y

const scaleBackgroundWidth = ({ w, crop, ...rest }) => {
  let { width } = crop || { width: 100 }
  if (width === 0) {
    width = 100
  }

  return scaleXtoY(w - 2 * calcBorder(rest), width)
}
const scaleBackgroundHeight = ({ h, crop, ...rest }) => {
  let { height } = crop || { height: 100 }
  if (height === 0) {
    height = 100
  }

  return scaleXtoY(h - 2 * calcBorder(rest), height)
}

const scalePositionX = ({ w, crop, ...rest }) => {
  let { width, x } = crop || { height: 100, x: 0 }
  if (width === 0) {
    return 0
  }

  return -1 * scaleBackgroundWidth({ w, crop: { width }, ...rest }) * (x / 100)
}
const scalePositionY = ({ h, crop, ...rest }) => {
  let { height, y } = crop || { height: 100, y: 0 }
  if (height === 0) {
    return 0
  }

  return -1 * scaleBackgroundHeight({ h, crop: { height }, ...rest }) * (y / 100)
}

const calcBorder = ({ borderType = 'noframe', borderWidth, perMeter }) => {
  if (borderType === undefined || borderType === 'noframe') {
    return 0
  }

  return perMeterCalc(borderWidth, perMeter)
}

export { getProp, getPropOrTheme, scaleBackgroundWidth, scaleBackgroundHeight, scalePositionX, scalePositionY }



// WEBPACK FOOTER //
// ./src/components/PreviewProduct/themeHelpers.js